import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtText from "../../../components/NtText";
import { useMobile } from "../../../hooks/useMobile";

function NtE911FeatureSection(props) {
  const isMobile = useMobile();
  const renderBox = (icon, title, description, containerStyle) => {
    return (
      <View
        style={[
          {
            flex: 1,
            padding: 15,
            paddingTop: 20,
            paddingBottom: 20,
            borderRadius: 10,
            backgroundColor: "#181818",
            alignItems: "center",
          },
          containerStyle,
        ]}
      >
        <NtMaterialIcon name={icon} color="#12ABFF" size={32} />
        <NtText
          style={{
            marginTop: 25,
            textAlign: "center",
            fontSize: 15,
            color: "white",
            fontWeight: "600",
          }}
        >
          {title}
        </NtText>
        <NtText
          style={{
            textAlign: "center",
            fontSize: 13,
            color: "white",
            fontWeight: "200",
            marginTop: 15,
          }}
        >
          {description}
        </NtText>
      </View>
    );
  };
  return (
    <NtMarketingSectionContainer style={styles.container}>
      <NtSectionTitle>Enhanced 911 Web Service</NtSectionTitle>
      <NtSectionDescription style={{ marginTop: 10, textAlign: "center" }}>
        Start providing 911 Emergency Services to your VoIP customers today!
      </NtSectionDescription>

      <View
        style={{ marginTop: 40, flexDirection: isMobile ? "column" : "row" }}
      >
        {renderBox(
          "code-json",
          "Easy API Integration",
          "We help communications companies deliver E9-1-1 quickly and easily.",
          { marginRight: isMobile ? 0 : 10, marginBottom: isMobile ? 10 : 0 }
        )}
        {renderBox(
          "currency-usd",
          "Competitive Pricing",
          "Our unique setup allows us to provide some of the lowest prices on the market.",
          { marginRight: isMobile ? 0 : 10, marginBottom: isMobile ? 10 : 0 }
        )}
        {renderBox(
          "globe-model",
          "Nationwide Coverage",
          "We provide 911 emergency service integration to most of the United States and Canada.",
          {}
        )}
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 80,
    paddingBottom: 80,
  },
});

export default NtE911FeatureSection;
